import { Controller } from "@hotwired/stimulus"
//import { DirectUpload } from "https://esm.sh/@rails/activestorage@8.0.100?standalone"
import Dropzone from "./dropzone.js"

export default class extends Controller {
  static values = {
    uploadUrl: String,
    assetUrl: String,
    refreshUrl: String,
    successUrl: String,
  }

  connect() {


    function createRandomString(length) {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    }
    this.hash = createRandomString(12);
    console.log("DropzoneController.connect()", this.hash)
    console.log(this.element);
    console.log("connect", this.assetUrlValue, this.refreshUrlValue, this.successUrlValue);
    this.dropZone = new ReviewDropzone({
      uploadUrl: this.uploadUrlValue,
      assetUrl: this.assetUrlValue,
      refreshUrl: this.refreshUrlValue,
      successUrl: this.successUrlValue,
    });
    // this.dropZone.enqueueFile = it => this.#upload(it)
  }

  disconnect() {
    console.log("DropzoneController.disconnect()", this.hash)
    console.log(this.dropZone);
    this.dropZone.destroy()
  }
}

class ReviewDropzone {
  dropzone;

  constructor({uploadUrl, assetUrl, refreshUrl, successUrl}) {
    console.log("ReviewDropzone created!");
    //, {uploadUrl, assetUrl, refreshUrl, successUrl});

    function csrfHeaders() {
      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");

      return { "X-CSRF-Token": csrfToken };
    }

    const previewNode = document.querySelector("#template");

    if (previewNode == null) {
      console.log("############## NULL PREVIEW NODE");
      return;
    }
    // console.log("previewNode: ", previewNode);

    // previewNode.id = "";


    const previewTemplate = previewNode.parentNode.innerHTML;
    previewNode.parentNode.removeChild(previewNode);

    const myDropzone = new Dropzone(document.body, { // Make the whole body a dropzone
      uploadMultiple: false,
      maxFilesize: 10000,
      url: uploadUrl, // Set the url in the sending method
      thumbnailWidth: 80,
      thumbnailHeight: 80,
      parallelUploads: 20,
      previewTemplate: previewTemplate,
      autoQueue: true, // Set to false if files aren't queued until manually added
      previewsContainer: "#previews", // Define the container to display the previews
      clickable: ".fileinput-button" // Define the element that should be used as click trigger to select files.
    });

    // Update the total progress bar
    myDropzone.on("totaluploadprogress", function(progress) {
      document.querySelector("#total-progress .progress-bar").style.width = progress + "%";
    });

    myDropzone.on("success", function(file, response){
      console.log("*********** success");

      $.ajax({
        url: successUrl,
        data: {asset: {name: file.name, size: file.size / 1000}},
        type: 'POST',
        headers: csrfHeaders(),
        success: function(response){
          console.log("Uploaded: ", file.name);
          $.ajax({
            type: "GET",
            url: refreshUrl,
            dataType: "html",
            headers: csrfHeaders(),
            success: function(response) {
              console.log("replaceWith");
              $("#asset-container").replaceWith(response);
            }
          });
        }
      });
    });

    myDropzone.on("sending", function(file, xhr, formData) {
      console.log("*********** sending");

      $.ajax({
        url: assetUrl,
        data: {asset: {name: file.name, content_type: file.type, size: (file.size / 1000)}},
        type: 'POST',
        async: false,
        headers: csrfHeaders(),
        statusCode: {
          400: function() {
            console.log("Canceled");
          },

          422: function() {
            console.log("Invalid!!");
          }
        },

        success: function(response){
          console.log("****************** sending.response", response);
          //clear formdata
          for (const pair of formData.entries()) {
            formData.delete(pair[0]);
          }

          $.each(response, function(k, v){
            console.log("APPEND", k, v);
            formData.append(k, v);
          });

          for (const pair of formData.entries()) {
            console.log("FINAL", pair[0], pair[1]);
          }
        },

        error: function(jqxhr, errorMsg, errThrown){
          alert(errorMsg);
        }
      });

      console.log("*********** Completed Send")

      // xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));

      console.log(formData);


      // Show the total progress bar when upload starts
      document.querySelector("#total-progress").style.opacity = "1";
    });

    // Hide the total progress bar when nothing's uploading anymore
    myDropzone.on("queuecomplete", function(progress) {
      console.log("************ queuecomplete")
      document.querySelector("#total-progress").style.opacity = "0";
      // $.ajax({
      //   type: "GET",
      //   url: assetUrl,
      //   async: true,
      //   dataType: "script",
      // });
    });

    myDropzone.on("error", function (file, message) {
      if (file && message) {
        if (message.startsWith('<?xml version')) {
          const search = /<Message>(.*?)<\/Message>/g.exec(message);
          message = search[1];
          console.log("Failed:", message);
          this.emit("error", file, message);
        }
      }
    });

    this.dropzone = myDropzone;
  }

  destroy() {
    console.log("ReviewDropzone.destroy!");
    this.dropzone = null;
    //this.dropzone.destroy();
  }
}

// class Uploader {
//   constructor(file, dropZone) {
//     this.file = file; this.dropZone = dropZone;
//   }

//   start() {
//     this.#createDirectUpload((error, blob) => {
//       if (error) {
//         this.#emitDropzoneError(error)
//       } else {
//         this.#createHiddenInput(blob.signed_id)
//         this.#emitDropzoneSuccess()
//       }
//     })
//   }

//   directUploadWillStoreFileWithXHR(xhr) {
//     this.file.xhr = xhr
//     this.#bindProgress()
//     this.#emitDropzoneProcessing()
//   }

//   #createDirectUpload(callback) {
//     new DirectUpload(this.file, this.dropZone.options.url, this).create(callback)
//   }

//   #createHiddenInput(signedId) {
//     this.hiddenInput = document.createElement("input")
//     this.hiddenInput.type = "hidden"
//     this.hiddenInput.name = this.dropZone.options.paramName
//     this.hiddenInput.value = signedId
//     this.file.previewElement.appendChild(this.hiddenInput)
//   }

//   #bindProgress() {
//     this.file.xhr.upload.addEventListener("progress", it => this.#directUploadDidProgress(it))
//   }

//   #directUploadDidProgress(event) {
//     this.dropZone._updateFilesUploadProgress([this.file], this.xhr, event)
//   }

//   #emitDropzoneProcessing() {
//     this.file.status = Dropzone.PROCESSING
//     this.dropZone.emit("processing", this.file)
//   }

//   #emitDropzoneSuccess() {
//     this.file.status = Dropzone.SUCCESS
//     this.dropZone.emit("success", this.file)
//     this.dropZone.emit("complete", this.file)
//   }

//   #emitDropzoneError(error) {
//     this.file.status = Dropzone.ERROR
//     this.dropZone.emit("error", this.file, error)
//     this.dropZone.emit("complete", this.file)
//   }
// }
